import { type ClassNameValue, twMerge } from "tailwind-merge";

type TwFn = {
	(arg: TemplateStringsArray, ...rest: string[]): string;
	(...args: Array<ClassNameValue>): string;
};

const isTemplateString = (
	arg: TemplateStringsArray | ClassNameValue,
): arg is TemplateStringsArray => {
	if (Array.isArray(arg) && arg.length > 0 && Object.hasOwn(arg, "raw")) return true;
	return false;
};

export const tw: TwFn = (...args) => {
	if (args?.length < 1) return "";
	const [first, ...rest] = args;

	if (isTemplateString(first)) {
		return first.reduce((acc, curr, i) => acc + curr + (rest[i] || ""), "");
	}

	return twMerge(first, ...rest);
};
